var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:_vm.classList,attrs:{"data-test-id":_vm.testId}},_vm.listeners),[_c('Icon',{attrs:{"icon":_vm.icon,"size":_vm.size,"rotate":_vm.rotate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }